import React from 'react';
import Modal from './Modal';

let Quote = require('../Managers/Quote');

const MHL = React.createClass({
    propTypes: {
        clearEmail: React.PropTypes.func,
        getEmail: React.PropTypes.func,
        forceRerender : React.PropTypes.func,
    },

    getInitialState() {
        return {
            loginActive: false,
            customerDetails : null,
            email : null,
        };
    },

    showLogin() {
        this.setState({
            loginActive: true
        });
    },

    hideLogin() {
        this.setState({
            loginActive: false
        });
    },

    closeLogin() {
        this.setState({
            loginActive: false
        });
        this.props.clearEmail();
    },
    mountCustomerDetails(customerDetails) {
        let _this = this;
        // now just use jquery to populate all the fields...urgh
        // load them all into variables

        let title = customerDetails.title;
        let otherTitle = undefined;
        let firstName = customerDetails.firstname;
        let lastName = customerDetails.lastname;
        let personaladdress1 = customerDetails.personaladdress1;
        let personaladdress3 = customerDetails.personaladdress3;
        let personaladdress5 = customerDetails.personaladdress5;
        let personalpostcode = customerDetails.personalpostcode;
        let phoneNumber = customerDetails.phone1;
        let email = customerDetails.email;
        let country = customerDetails.country;
        let isForeignAddress = customerDetails.isForeignAddress;
        let dob = null;

        // do some title magic
        switch (title) {
            case "Mr" :
            case "Mrs" :
            case "Miss" :
            case "Ms" :
                // do nothing
                break;
            default :
                // anything else, title becomes "Other" and "other_title"
                // becomes the title
                otherTitle = title;
                title = 'Other';
            break;

        }

        // need to sort out the address madness
        let corAddressLine1 = '';
        let corAddressLine2 = '';
        let corAddressLine3 = '';
        let corAddressPostcode = personalpostcode;
        let corCountry = country;

        /*
        if we have a pa5, that becomes 3, 3 becomes 2, and whatever is in
        1 becomes 1
        if we dont, and we have chunks in 1, the last chunk becomes 2. if we dont
        and we DONT have chunks in 1, we just simply dont have a 2
         */
        if (personaladdress5 != undefined) {
            corAddressLine3 = personaladdress5;
            corAddressLine2 = personaladdress3;
            corAddressLine1 = personaladdress1;
        } else {
            corAddressLine3 = personaladdress3;
            // need to split out pa1, it might cover multiple things
            let addressLine1Chunks = [];
            if (personaladdress1 != undefined) {
                addressLine1Chunks = personaladdress1.split(',');
            }
            if (addressLine1Chunks.length > 1) {
                corAddressLine2 = addressLine1Chunks[addressLine1Chunks.length-1];
                addressLine1Chunks.splice(addressLine1Chunks.length-1, 1);
                corAddressLine1 = addressLine1Chunks.join(", ");
            } else {
                corAddressLine1 = addressLine1Chunks.join(", ");
            }
        }

        // inverse the foreign address for is cor address uk
        let isCorAddressUk = 'yes';
        if (isForeignAddress == 'yes') {
            isCorAddressUk = 'no';
        }

        // split out the date of birth into date, month and year
        let dobDate = '';
        let dobMonth = '';
        let dobYear = '';
        if (customerDetails.date_of_birth_at != '' && customerDetails.date_of_birth_at != ' ' && customerDetails.date_of_birth_at != null && customerDetails.date_of_birth_at != undefined) {
            dob = customerDetails.date_of_birth_at;
            dob = dob.split('-');
            dobYear = dob[0];
            dobMonth = dob[1];
            dobDate = dob[2];
            dob = dobDate + '/' + dobMonth + '/' + dobYear;
        }

        // update the quote
        Quote.set('email_address', email);
        Quote.set('title', title);
        if (otherTitle != undefined) {
            Quote.set('other_title', otherTitle);
        }
        Quote.set('first_name', firstName);
        Quote.set('last_name', lastName);
        if (dob != null) {
            Quote.set('date_of_birth_at', dob);
        }
        Quote.set('phone_number', phoneNumber);
        Quote.set('is_cor_address_uk', isCorAddressUk);
        Quote.set('cor_address_line1', corAddressLine1);
        Quote.set('cor_address_line2', corAddressLine2);
        Quote.set('cor_address_line3', corAddressLine3);
        Quote.set('cor_address_postcode', corAddressPostcode);
        if (corAddressPostcode != '' && corAddressPostcode != null && corAddressPostcode != undefined) {
            Quote.set('cor', Quote.getCurrentAnswer('cor_address_postcode'));
        }
        Quote.set('country', corCountry);

        Quote.set('is_logged_into_myhomelet', true);
        Quote.set('myhomelet_email', email);

        // FAKING A PROMISE
        setTimeout(function() {
            _this.props.forceRerender();
            window.$('#email_address').prop('disabled', true);
        }, 500);
    },
    render() {
        let tp = {};
        let cb = {
            classes: "btn btn-success",
            text: "Login"
        };
        return (
            <div className="mhlBar">
                {this.state.loginActive ?
                <Modal
                    clearEmail={this.props.clearEmail}
                    getEmail={this.props.getEmail}
                    forceRerender={this.props.forceRerender}
                    isActive={this.state.loginActive}
                    bodyTemplate="mhl-login"
                    templateProps={tp}
                    closeFunction={this.closeLogin}
                    hideLogin={this.hideLogin}
                    mountCustomerDetails={this.mountCustomerDetails}
                    title="Sign in to My HomeLet"
                    closeButton={cb}
                /> : null}
            </div>
        );
    }
});

export default MHL;



/** WEBPACK FOOTER **
 ** ./src/components/Fragments/MHL.js
 **/